
import { defineComponent } from "vue";
import router from "@/router";
import currentPageTitle from "@/global/currentPageTitle";

import accessToken from "@/global/apiAccessToken";

export default defineComponent({
  setup() {
    const pageTitle = currentPageTitle.getTitle;
    return { pageTitle, router };
  },
  methods: {
    logUserOut() {
      accessToken.logUserOut();
    },
    redirectHome() {
      router.push("/");
    },
  },
  mounted() {
    currentPageTitle.setTitle("My storage");
  },
});
